// extracted by mini-css-extract-plugin
module.exports = {"DataShopping":"DataShopping_DataShopping__1xp1S"};